module.exports = __webpack_public_path__ + "img/training.189173ed.svg";